import { BTM, BTM_KEY } from 'core/constants/products'

function isBTMPlan(plan): boolean {
  return plan && (plan.productId ? plan.productId === BTM : plan.planType === BTM_KEY)
}

export default isBTMPlan
